const EP = "https://cdn.shopify.com/s/files/1/0674/8595/8369/t/3/assets/interview-data.json";


const DATA = {
    JSON: {},
    RESULTS: {
        "S": "至急動物病院で受診されることをお勧め致します。",
        "A": "回答を記録しました。回答内容は、サマリーとしてかかりつけ動物病院にお見せ頂けます。重い病気の可能性があります。すぐにかかりつけ動物病院にご相談されることを強くおすすめします。",
        "B": "回答を記録しました。回答内容は、サマリーとしてかかりつけ動物病院にお見せ頂けます。病気の可能性があります。早めにかかりつけ動物病院にご相談されることをおすすめします。",
        "C": "回答を記録しました。回答内容は、サマリーとしてかかりつけ動物病院にお見せ頂けます。病気の可能性は高くなさそうですが、気になるようでしたらかかりつけ動物病院で診察をしてください。",
        "D": "回答を記録しました。回答内容は、サマリーとしてかかりつけ動物病院にお見せ頂けます。気になることがあれば早めにかかりつけ動物病院に相談しましょう。",
    }
}

/**
 * CAT 選択中の診断項目
 * CURRENT 選択中の質問項目
 * SELECTED 選択した回答
 */
const STATUS = {
    CAT: "",
    CURRENT: "",
    DONE: [],
    SELECTED: [],
    FREE_DESCRIBE: [],
    EL: {
        root: document.getElementById("root"),
        first: document.getElementById("first-quest"),
        diagnostic: document.getElementById('diagnostic'),
        footerArea: document.getElementById('footer-area'),
        resutlArea: document.querySelector('#result .res-body'),
        mypageHeader: document.querySelector('.mypage--header')
    },
    REQUEST: {
        TPL: []
    }
};
/**
 * 診断項目を組み込み
 */
const setChatCategory = () => {
        const optionsEl = STATUS.EL.first.querySelector(".bl_chat-options")
        optionsEl.innerHTML = ""
        optionsEl.innerHTML = `
    ${
      Object.keys(DATA.JSON).map(cat=>`
      <li
      onclick="startDiagnostic('${cat}')"
      class="bl_chat-option">
      ${cat}
      </li>`).join(' ')
    }
 `
}
/**
 * 診断を開始
 * @param {*} cat
 */
const startDiagnostic = (cat) => {
  STATUS.CAT = cat
  STATUS.CURRENT = '1'
  STATUS.EL.first.classList.add("ban")
  const {title,type,options} = DATA.JSON[STATUS.CAT][STATUS.CURRENT]
  setOptions(title,type,options,STATUS.CAT)
}
/**
 * 複数回答を取得
 */
const getMultiAnswer = (title) => {
  STATUS.REQUEST.TPL = []
  const checkedEl = [...document.querySelectorAll(`input[name=${title}]`)]
  .filter(input=>input.checked)
  if(!checkedEl.length){
    return window.alert('最低1つ選択してください。')
  }
  const checkedAnswers = checkedEl.reduce((a,e)=> {
    const {priority,label,next} = e.dataset
    if(a.label === undefined) {
      a.label = []
      a.priority = []
      a.next = ""
    }
    a.label.push(label)
    a.priority.push(priority)
    a.next = next
    return a
  },{})

 STATUS.REQUEST.TPL = [checkedAnswers.next,[checkedAnswers.priority],checkedAnswers.label.join('、'),DATA.JSON[STATUS.CAT][STATUS.CURRENT].options]
 setNextQuest(...STATUS.REQUEST.TPL)
  // if(checkedEl.find(el=>el.dataset.label === 'その他（自由記述）')){
  // setOtherQuest('other')
  //   // STATUS.FREE_DESCRIBE.push({
  //   //   title,
  //   //   text: reason
  //   // })
  // } else {
  //   setNextQuest(...STATUS.REQUEST.TPL)
  // }
}
/**
 * 回答を選択(single)
 * @param {*} answer 回答
 */
const setAnswer = (answer,title) => {
  STATUS.REQUEST.TPL = []
  const {priority,next,label} = DATA.JSON[STATUS.CAT][STATUS.CURRENT].options[answer]
  STATUS.REQUEST.TPL = [next,priority,label,DATA.JSON[STATUS.CAT][STATUS.CURRENT].options]
  if(label === 'その他（自由記述）') {
    return setOtherQuest('other')
    // STATUS.FREE_DESCRIBE.push({
    //   title,
    //   text: reason
    // })
  } else if(label === '写真を記録する。') {
  return setOtherQuest('photo')
  } else {
    setNextQuest(...STATUS.REQUEST.TPL)
  }
}
const setNextQuest = (next,priority,label) => {
  STATUS.REQUEST.TPL = []
  //選択したpriorityを格納
  STATUS.SELECTED.push(...priority)
  // nextが存在すれば次の設問へ
  if(next){
    STATUS.DONE.push(STATUS.CURRENT)
    STATUS.CURRENT = next
    const {title,type,options} = DATA.JSON[STATUS.CAT][STATUS.CURRENT]
    setOptions(title,type,options,label)
  } else {
    let inputUpload = "UPLOAD_IMAGE_"+STATUS.CURRENT;
    setResult(label)
    postChatData(inputUpload);
  }
}
/**
 * 設問を作成
 * @param {*} title
 * @param {*} type multi:複数回答 single:単一回答
 * @param {*} options 選択肢
 * @param {*} answer 回答
 */
const setOptions = (title,type,options,answer) => {
  const prevB = STATUS.EL.diagnostic.getBoundingClientRect().bottom
 STATUS.EL.diagnostic.insertAdjacentHTML('beforeend',`
 <li class="bl_chat-item">
 <div class="bl_chat ly_right">
      <p class="bl_chat-answer">${answer}</p>
  </div>
  <div class="bl_chat ly_left">
   <p class="bl_chat-quest">${title}</p>
   <ul class="bl_chat-options">
   ${options.map((option,index)=>
    type === 'single' ? `
    <li
    onclick="setAnswer('${index}','${title}')"
    class="bl_chat-option">
      ${option.label}
    </li>` : `
    <li
    class="bl_chat-option multi">
    <label
    >
    <input type="checkbox"
    ${
      option.label === 'その他（自由記述）' ? `
      onChange='toggleHidden("FREE_DESCRIBE_${STATUS.CURRENT}")'
      ` : ''
    }
    ${
      option.label === '特に気になることはない' ? `
      onChange='dissableOtherItem(event,${index})'
      ` : ''
    }
    ${
      option.label !== '特に気になることはない' && option.label !== 'その他（自由記述）'  ? `
      onChange='dissableOtherItem(event)'
      ` : ''
    }
    name="${title}"
    data-priority="${option.priority}"
    data-label="${option.label}"
    data-next="${option.next}"/>
    <span></span>
      ${option.label}
    </label>
    ${
      option.label === 'その他（自由記述）' ? `
      <textarea
      class="hidden"
      name="free_describe"
      id="FREE_DESCRIBE_${STATUS.CURRENT}" cols="30" rows="3"
      placeholder="気になることを記載してください。"
      data-title="${DATA.JSON[STATUS.CAT][STATUS.CURRENT].title}"></textarea>
      ` : ''
    }
    </li>`
   ).join(" ")}
   ${
    STATUS.CURRENT != 1 ? `
    <li
    onclick="backToPreviousQuest('back')"
    class="bl_chat-option back">
      前の質問に戻る
    </li>` : `
    <li
    onclick="backToPreviousQuest('reset')"
    class="bl_chat-option back">
      問診項目一覧に戻る
    </li>`
   }
   ${
    type === 'multi' ? `
    <li
    onclick="getMultiAnswer('${title}')"
    class="bl_chat-option answer multi-answer"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
  </svg>
    選択した内容で回答する
    </li>` : ''
   }
   </ul>
  </div>
 </li>
 `)
 scrollToNextQuest(prevB)
}
/**
 * 質問項目を作成
 */
const setOtherQuest = (type) =>{
  const prevB = STATUS.EL.diagnostic.getBoundingClientRect().bottom
  STATUS.EL.diagnostic.insertAdjacentHTML('beforeend',`
    <li class="bl_chat-item">
    <div class="bl_chat ly_right">
        <p class="bl_chat-answer">${type === 'other' ? 'その他（自由記述）' : '写真を記録する。'}</p>
     </div>
     <div class="bl_chat ly_left">
     <p class="bl_chat-quest">${type === 'other' ? 'その他の気になることを記載してください。' : '写真を選択してください。'}</p>
      <ul class="bl_chat-options">
      <li
      class="bl_chat-option">
       ${type === 'other'? `
       <textarea name="free_describe" id="FREE_DESCRIBE_${STATUS.CURRENT}" cols="30" rows="3" placeholder="気になることを記載してください。" data-title="${DATA.JSON[STATUS.CAT][STATUS.CURRENT].title}"></textarea>
       ` : `
       <label for="UPLOAD_IMAGE_${STATUS.CURRENT}" class="image_uploader">
       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-image" viewBox="0 0 16 16">
       <path d="M6.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
       <path d="M14 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5V14zM4 1a1 1 0 0 0-1 1v10l2.224-2.224a.5.5 0 0 1 .61-.075L8 11l2.157-3.02a.5.5 0 0 1 .76-.063L13 10V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4z"/>
     </svg>写真を選択する</label>
     <input
     type="file"
     name="update_image"
     id="UPLOAD_IMAGE_${STATUS.CURRENT}"
     accept="image/*" placeholder="写真を選択してください"
     data-title="${DATA.JSON[STATUS.CAT][STATUS.CURRENT].title}"
     onChange="setImage('UPLOAD_IMAGE_${STATUS.CURRENT}','SRC_IMAGE_${STATUS.CURRENT}')"
     >
     <img src=""
     id="SRC_IMAGE_${STATUS.CURRENT}"
     alt="" />
       `}
      </li>
      <li
       onclick="answerOther(${type === 'other'?
       `'FREE_DESCRIBE_${STATUS.CURRENT}','other'` :
       `'UPLOAD_IMAGE_${STATUS.CURRENT}','photo'`})"
       class="bl_chat-option answer">
       ${type === 'other'? '記載した内容で回答する' : '選択した写真で回答する'}
       </li>
      </ul>
     </div>
    </li>
    `)

  scrollToNextQuest(prevB)
}
/**
 * 次の設問へスクロールする
 * @param {*} prevB
 * @returns
 */
const scrollToNextQuest = (prevB) =>{
  window.scroll({
    top:  prevB+window.scrollY - STATUS.EL.mypageHeader.clientHeight,
    behavior:'smooth'
  })
}
const setImage = (UPLOAD_IMAGE_ID,SRC_IMAGE_ID) =>{
  const UPLOAD_IMAGE = document.getElementById(UPLOAD_IMAGE_ID),
  PREVIEW = document.getElementById(SRC_IMAGE_ID)
  if(!UPLOAD_IMAGE.value) return
  const file = UPLOAD_IMAGE.files[0];
  const FR = new FileReader();

  FR.addEventListener(
    "load",
    () => {
      // 写真ファイルを base64 文字列に変換します
      PREVIEW.src = FR.result;
    },
    false,
  );

  if (file) {
    FR.readAsDataURL(file);
  }
  PREVIEW.style.marginTop = '8px'
}
const answerOther = (id,type) =>{
  const trg = document.getElementById(id)
  if(!trg.value) return window.alert(`${type === 'other'?'理由を記載してください':'写真を選択してください。'}`)
  setNextQuest(...STATUS.REQUEST.TPL)
}
/**
 * 回答した選択肢をラベルに反映
 * @param {*} val
 */
const setStatus = (val) => {
  STATUS.CURRENT = val;
  if (STATUS.CURRENT) {
    const { label, options } = DATA.JSON[STATUS.CURRENT];
    STATUS.EL.diagnostic.querySelector(".label").innerHTML = `${label}`;
    STATUS.EL.diagnostic.querySelector("ul").innerHTML = `
      ${options
        .map(
          (option) =>
          `<li onclick="document.getElementById('nextOption').setAttribute('data-next',${option.next})">${option.label}</li>`
        )
      .join("")}
    `;
  }
};
/**
 * 診断結果を表示
 */
const setResult = (label)=>{
  const answers = [...document.querySelectorAll(".bl_chat-answer")].map(a=>a.innerText)
  STATUS.EL.diagnostic.insertAdjacentHTML('beforeend',`<li class="bl_chat-item"><div class="bl_chat ly_right"><p class="bl_chat-answer">${label}</p></div></li><li class="bl_chat-item"></li>`)
  STATUS.EL.resutlArea.innerHTML = ""
  //選択肢を配列化
  const results = [...STATUS.SELECTED.flat()]
  if(results.includes('S')){
    STATUS.EL.resutlArea.innerHTML = DATA.RESULTS.S
  } else if(results.includes('A')){
    STATUS.EL.resutlArea.innerHTML = DATA.RESULTS.A
  } else if(results.includes('B')){
    STATUS.EL.resutlArea.innerHTML = DATA.RESULTS.B
  } else if(results.includes('C')){
    STATUS.EL.resutlArea.innerHTML = DATA.RESULTS.C
  } else {
    STATUS.EL.resutlArea.innerHTML = DATA.RESULTS.D
  }
  STATUS.EL.footerArea.classList.remove('hidden')
  const {y,height} = STATUS.EL.diagnostic.getBoundingClientRect()
  window.scroll({
    top: y+height + window.scrollY,
    behavior:'smooth'
  })
  const FREE_DESCRIBES = [...document.querySelectorAll('.bl-input-text')]
  if(FREE_DESCRIBES.length){
    STATUS.FREE_DESCRIBE = FREE_DESCRIBES.reduce((a,el)=>{
      a.push({
        title: el.dataset.name,
        text: el.value
      })
      return a
    },[])
  }
  if(answers.find(a=>a === "赤やピンク色")){
    STATUS.EL.resutlArea.insertAdjacentHTML("beforeEnd","<br><span style='font-size:12px'>※Buddy FOOD #06豚ハツを食べると、メニューに含まれるビーツのポリフェノールの色素により、尿に赤みが出る場合がありますが、それ自体には健康に悪影響はございません。</span>")
  }
}
const closeModal = () =>{
  document.getElementById('image_modal').classList.add('hidden')
}
/**
 * テキストエリアのトグルイベント
 * @param {*} id
 * @returns
 */
const toggleHidden = (id)=>{
  const trg =  document.getElementById(id)
  return trg.classList.contains('hidden') ? trg.classList.remove('hidden'):trg.classList.add('hidden')
}
/**
 * 他の選択肢をdissableにする
 */
const dissableOtherItem = (event,_index)=>{
  const parentNode = event.target.parentNode.parentNode.parentNode
  const items = [...parentNode.querySelectorAll('.multi')]
  if(_index !== undefined){
    items.map((item,index)=>{
      if(index == _index) return
      if(item.classList.contains('dissable')){
        item.classList.remove('dissable')
      }else{
        item.classList.add('dissable')
        if(item.querySelector("input").checked) item.querySelector("input").checked = false
      }
    })
  } else if(items.find(item=>item.innerText === '特に気になることはない')) {
    const _trg = items.find(item=>item.innerText === '特に気になることはない')
   if(items.filter(item=>item.querySelector("input").checked).length){
    _trg.classList.add('dissable')
   } else {
    _trg.classList.remove('dissable')
  }
  }
}
/**
 * 前の設問に戻る
 */
const backToPreviousQuest = (mode) =>{
  document.body.style.pointerEvents = 'none';
  const items = [...STATUS.EL.diagnostic.querySelectorAll('.bl_chat-item')]
  if(mode === 'back'){
  const prevItem = items[items.length -2]
  const scrollMount = prevItem.getBoundingClientRect().height > window.innerHeight ? prevItem.getBoundingClientRect().top + window.scrollY : prevItem.getBoundingClientRect().top + window.scrollY - (window.innerHeight - prevItem.getBoundingClientRect().height) + STATUS.EL.mypageHeader.clientHeight;
        window.scrollTo({
            top:scrollMount,
            behavior:'smooth'
        })
  } else if(mode=== 'reset'){
    window.scrollTo({
      top:0,
      behavior:'smooth'
  })
  }

  setTimeout(()=>{
    document.body.style.pointerEvents = 'visible';
    items.pop().remove()
    STATUS.CURRENT = STATUS.DONE.pop()
    STATUS.SELECTED.pop()
    if(mode === 'reset'){
      STATUS.EL.first.classList.remove("ban")
      STATUS.CAT = ""
      STATUS.CURRENT = ""
      STATUS.DONE = []
      STATUS.SELECTED = []
      STATUS.FREE_DESCRIBE = []
    }
  },1000)
}
/**
 * JSONを取得
 */
const getJson = async() =>{
  const res = await fetch(EP)
  const json = await res.json()
  DATA.JSON = json
  setChatCategory()
}
getJson()


function postChatData(inputUpload) {
  var category = STATUS.CAT;
  var selectDogId = $('#selectDog').val();
  let url = "/apps/api/interview/upload";
  let formData = new FormData();
  formData.append('category', category);
  let fileInput = document.getElementById(inputUpload);
  if (fileInput != null) {
    let file = fileInput.files[0];
    formData.append('image', file);
  }
  var chatData = [];
  var chatQuestions = [];
  var chatAnswers = [];
  $('.bl_chat-quest').each(function() {
    var question = $(this).text().trim();
    chatQuestions.push(question);
  });

  $('.bl_chat-answer').each(function() {
      var answer = $(this).text().trim();
      chatAnswers.push(answer);
  });

  for (var i = 0; i < Math.min(chatQuestions.length, chatAnswers.length); i++) {
      chatData.push({ question: chatQuestions[i], answer: chatAnswers[i] });
  }
  formData.append('chatData', JSON.stringify(chatData));

  $.ajax({
    type: 'POST',
    url: url,
    data: formData,
    contentType: false,
    processData: false,
    success: function(response) {}
  });
}